{"rating":"4.9","reviewCount":"141","fetchedAt":"2026-10-17T00:52:55.362Z","source":"place-details"}